function updateHomepageLinks() {
  document.querySelectorAll(".product-item").forEach(function (item) {
    const collectionHandle = item.getAttribute("data-collection-handle");
    const productHandle = item.getAttribute("data-product-handle");

    if (collectionHandle && productHandle) {
      const newUrl = `/collections/${collectionHandle}/products/${productHandle}`;

      const imageLink = item.querySelector(".card-link");
      if (imageLink) imageLink.setAttribute("href", newUrl);

      const titleLink = item.querySelector(".product-title-link");
      if (titleLink) titleLink.setAttribute("href", newUrl);
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  updateHomepageLinks();
  setTimeout(updateHomepageLinks, 1000);

  const observer = new MutationObserver(updateHomepageLinks);
  observer.observe(document.body, { childList: true, subtree: true });
});
